import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstcharcateruppercase'
})
export class FirstCharacterUpperCase implements PipeTransform {
  transform(value: string, args?: any): any {
    if (value === null) return value;
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/capitalizeUpperCase.pipe.ts